import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import IntlMessage from '../../../../../helpers/intlMessage';

import TableReport from '@componentes/TableReport';

function Sepultamento ({ lista }) {
  const headerListItens = [
    <IntlMessage id = "dashboards.reports.exam"/>,
    <IntlMessage id = "dashboards.reports.bottle"/>,
    <IntlMessage id = "dashboards.reports.patientCivilRegistry"/>,
    <IntlMessage id = "dashboards.reports.socialName"/>,
    <IntlMessage id = "dashboards.reports.material"/>,
    <IntlMessage id = "dashboards.reports.burialRequestingPhysician"/>,
    <IntlMessage id = "dashboards.reports.deliveryDate"/>
  ];

  const [headerList, setHeaderList] = useState(headerListItens);

  const [listaFormatada, setListaFormatada] = useState([]);
  const [titulo, setTitulo] = useState('');
  const [mostrarDataEntrega, setMostrarDataEntrega] = useState(true);

  const tab = useSelector(state => state.descarteCommon.tab);

  function formatList (list) {
    const relatorioListaFormated = list.map(item => ({
      ...item,
      medicoResponsavelDescarte: item.medicoResponsavelDescarteId
        ? `${item.medicoResponsavelDescarteId} ${item.medicoResponsavelDescarte}`
        : ''
    }));
    setListaFormatada(relatorioListaFormated);
  }

  useEffect(() => {
    if (!mostrarDataEntrega) {
      setHeaderList(headerListItens.filter(x => x !== <IntlMessage id = "dashboards.reports.deliveryDate"/>));
    } else {
      setHeaderList(headerListItens);
    }
  }, [mostrarDataEntrega]);

  useEffect(() => {
    verificarMostrarDataEntrega();
  }, [listaFormatada]);

  function verificarMostrarDataEntrega () {
    const mostrar =
      listaFormatada.map((elem, i) => elem.dataEntrega !== '').indexOf(true) >
      -1;
    setMostrarDataEntrega(mostrar);
  }

  function carregarTitulo () {
    switch (tab) {
      case '1':
        setTitulo(
          <IntlMessage id = "dashboards.reports.reportBurial"/>
        );
        break;
      case '3':
        setTitulo(<IntlMessage id = "dashboards.reports.registrationBurial"/>);
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    carregarTitulo();
  }, [tab]);

  useEffect(() => {
    formatList(lista);
  }, [lista]);

  return (
    <TableReport
      title={titulo}
      assinatura={<IntlMessage id = "dashboards.reports.subscriptionCRM"/>}
      headerList={headerList}
    >
      {listaFormatada.map((item, i) => (
        <tr key={i}>
          <td>{item.numeroExame}</td>
          <td>{item.idFrasco}</td>
          <td>{item.paciente}</td>
          <td>{item.pacienteNomeSocial}</td>
          <td>{item.nomeMaterial}</td>
          <td>{item.medicoResponsavelDescarte}</td>
          {mostrarDataEntrega && <td>{item.dataEntrega}</td>}
        </tr>
      ))}
    </TableReport>
  );
}

Sepultamento.propTypes = {
  lista: PropTypes.array.isRequired
};

Sepultamento.defaultProps = {
  lista: []
};

export default Sepultamento;



// WEBPACK FOOTER //
// ./src/pages/descarte/common/components/Sepultamento/index.js